export function ErrorMessage({ children }: { children: React.ReactNode }) {
  return (
    <p className="mx-5 max-w-2xl text-center text-sm text-balance text-gray-600">
      {children}
    </p>
  );
}
